<template>
  <div>
    <div
      v-if="list !== null"
      class="alert-handler-list"
    >
      <h3>
        {{ title ? 'title' : list.length ? $t('messages.alarms.programsAffected') : $t('messages.alarms.noProgramsAffected') }}
      </h3>
      <ol class="alert-handler-list__numbered-list">
        <li
          v-for="(item, key, index) in list"
          :key="index"
        >
          <h3
            v-if="item.programs[0].ID === '-1'"
            class="manually-started"
          >
            {{ $t('messages.sharedTexts.manuallyStarted') }} {{ $tc('messages.sharedTexts.stations.station', 0) }}
          </h3>
          <programs-mini
            v-else
            :programs="item.programs"
          />

          <mini-stations-element
            v-if="item.stations"
            :stations="getStations(item)"
          />
        </li>
      </ol>
    </div>

    <div
      v-else
      class="alert-handler-list__spinner"
    />
  </div>
</template>

<script>
import ProgramsMini from '@/components/elements/MiniProgramsElement'
import MiniStationsElement from '@/components/elements/MiniStationsElement'
import _ from 'lodash'

export default {
  name: 'AlertHandlerList',
  components: {
    'programs-mini': ProgramsMini,
    'mini-stations-element': MiniStationsElement,
  },
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    },
    title: {
      type: String,
      default() {
        return ''
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    // computedProgramsLength() {
    //   const hasManuallyStartedStations = this.list.findIndex(item => {
    //     item.programs[0].ID === '-1'
    //   }) !== -1
    //   return hasManuallyStartedStations ? this.list.length - 1 : this.list.length 
    // }
  },
  watch: {
  },
  mounted() {
    setTimeout(() => {
      console.log(this.list)
    }, 2000)
  },
  methods: {
    getStations(item) {
      return _.uniqBy(item.stations, 'StId')
    },
    SetPageMessage(Message) {
      this.$emit('SetPageMessage', Message)
    }
  }
}
</script>

<style lang="scss">
.alert-handler-list {
  box-sizing: border-box;
  background: $color-white;
  padding: 10px 20px;
  max-width: 100vw;
  width: 100%;

  h3 {
    margin: 10px 0;

    &.manually-started {
      margin-bottom: 10px;
    }
  }
  
  &__spinner {
    @include spinner('after', 80px, 5px, $color-grey);
    &:after {
      display: block;
      margin: 10px auto 25px;
    }
  }

  &__programs {
    padding-left: 19px;
    ol {
      margin-left: 5px;
    }
    >li {
      $spacing: 15px;
      margin-top: $spacing;

      &:first-child {
        margin-top: $spacing;
      }

      &:not(:last-child){
        padding-bottom: $spacing;

        &::after {
          content: " ";
          display: block;
          padding-top: $spacing;
          border-bottom: 1px solid $color-grey;
        }
      }
    }
  }

  &__numbered-list {
    margin-left: 20px;
    text-align: left;
    > li {
      margin-top: 15px;
    }
  }
}
</style>
